import React, { useEffect, useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import ajaxBanking from '../../util/remote/ajaxBanking';
import { useBanking } from '../../DataStore/BankingContext';

const AlertDeleteBank = ({show, onClose, bank}) => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const {getBanks } = useBanking();

  
    const handleClose = ()=>{
        onClose();
    }

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxBanking.deleteBank({bank_id: bank?.bank_id});
        setLoading(false);
        if(server_response.status === "OK"){
            await getBanks(true);
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)
        }
        onClose();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title="Delete Bank"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    {bank && <button className="btn btn-danger" onClick={confirm}>
                        Confirm Delete
                    </button>}
                    </>}
                </>
            }
        >


            {bank && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Please confirm that you want to delete this bank, <i>{bank.bank_name}</i>.</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>Please ensure that the account is unlinked before deleting. The records of the linked ledger account will not be deleted.
                </p>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDeleteBank;
